/** Only a validated explicit Build directive can acquire this presentation marker. */
export function validatedBuildUIAction(value: unknown, verifiedBuild: boolean): 'build_campaign' | undefined {
  return value === 'build_campaign' && verifiedBuild ? 'build_campaign' : undefined;
}

export function isBuildCampaignAction(message: {role?: unknown; uiAction?: unknown}): boolean {
  return message.role === 'user' && message.uiAction === 'build_campaign';
}

/** Keep the current directive for retry deduplication; older UI actions are
 * already represented by their results and remain in canonical saved history. */
export function includeInBuildModelHistory(message: {role?: unknown; uiAction?: unknown; id?: unknown}, currentUserMessageId?: string): boolean {
  return !isBuildCampaignAction(message) || (currentUserMessageId !== undefined && message.id === currentUserMessageId);
}
